import { useFeatureFlags } from "@/hooks/useUser"
import { decodeParams } from "@/organisms/Drawers/applications/common/common"
import { useBranchEntity } from "@/organisms/Drawers/applications/inventory/useInventory"
import { TAB_NAMES, WIDTH_DEFAULT } from "@/organisms/Drawers/const"
import { useDrawer } from "@/organisms/Drawers/hooks/useDrawer"
import { CodeIssueTab } from "../CodeIssueTab"
import { CodeRepoConfigTab } from "../ConfigTab/ConfigTab"
import { SbomTab } from "../SbomTab"
import { TabComponentProps, TabsDrawerTemplate } from "../TabsDrawerTemplate"
import { useAgentInventory } from "./components/Agents/useAgentInventory"
import { AgentsTab } from "./components/AgentsTab"
import { IssuesTabCodeRepoDrawer } from "./components/IssuesTabCodeRepoDrawer"
import { OverviewTabCodeRepositoryDrawer } from "./components/OverviewTabCodeRepositoryDrawer"
import { TitleCodeRepositoryDrawer } from "./components/TitleCodeRepositoryDrawer"

import type { CodeRepositoryDrawerComponent } from "./CodeRepositoryDrawer.types"

export const CodeRepositoryDrawer: CodeRepositoryDrawerComponent = ({
  widthAdditive,
  ...props
}) => {
  const showCodeIssueTab = useFeatureFlags("sastScanFeature")

  // The Agents tab is for internal tenants, gated on the same server-driven feature flag the side
  // navigation uses for internal-only items, and only for a repo that has an agent inventory. Same
  // queries the tab reads, so the repo and its inventory are fetched once
  const isInternalTenant = useFeatureFlags("isInternalTenant")
  const { searchParams } = useDrawer(props.id)
  const recordId = decodeParams(searchParams.get(props.id) || "")?.record?.id
  const [, { repositoryName }] = useBranchEntity(recordId)
  const { inventory } = useAgentInventory(
    isInternalTenant ? repositoryName : undefined
  )
  const showAgents = !!isInternalTenant && !!inventory

  const tabs = [
    "overview",
    "sbom",
    "scaIssues",
    showCodeIssueTab ? "sastIssues" : null,
    "config",
    showAgents ? TAB_NAMES.agents : null
  ].filter(Boolean) as string[]

  const components = [
    OverviewTabCodeRepositoryDrawer,
    SbomTab,
    IssuesTabCodeRepoDrawer,
    showCodeIssueTab ? CodeIssueTab : null,
    CodeRepoConfigTab,
    showAgents ? AgentsTab : null
  ].filter(Boolean) as React.FC<TabComponentProps>[]

  return (
    <TabsDrawerTemplate
      name="CodeRepositoryDrawer"
      tabs={tabs}
      components={components}
      Title={TitleCodeRepositoryDrawer}
      width={WIDTH_DEFAULT + widthAdditive}
      {...props}
    />
  )
}
